import TextBase from '../text';
import { Colors } from '../../themes/Colors';
import { convertPxToRem } from '../../helper';
import { CreateaccountButton } from '../../modules/child-accounts';
const intervals = { month: "monthly", year: "yearly" };

export const SubscriptionHeader = ({
  showChange = false,
  btnText = 'cancel',
  leftTitle = 'subscription',
  subscription = {},
  onClickRight = () => { },
  onReactivate = () => { },
  onActivate = () => { },
}) => {
  const subscriptionType = intervals[subscription?.plan?.interval] || "";

  const currentPeriodEnd = subscription?.subscription?.current_period_end;
  const isCancelled = new Date(currentPeriodEnd) < new Date() || subscription?.subscription?.cancel_at_period_end;
  const isExpired = new Date(currentPeriodEnd) < new Date() && !subscription?.subscription?.canceled_at;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: 'var(--sp-lg)'
      }}>
      <div style={{ display: 'flex' }}>
        {showChange && (
          <TextBase style={{}} fontWeight={400} size={'var(--fs-body)'} color={Colors.titlePage}>
            type
          </TextBase>
        )}

        <TextBase
          style={{ marginLeft: 'var(--sp-sm)' }}
          fontWeight={600}
          size={'var(--fs-body)'}
          color={Colors.titlePage}>
            {leftTitle} {subscriptionType && '/'} {subscriptionType}
        </TextBase>
      </div>
      <div
        style={{
          flex: 1,
          height: 'calc(var(--fs-xs)*0.09433962)',
          marginLeft: 'var(--sp-lg)',
          backgroundColor: '#E5E7EB'
        }}
      />

      <div style={{ display: 'flex' }}>
        <>
          {
            isExpired ? (
              <div
                style={{ marginLeft: 'var(--sp-lg)' }}
                className="show-cursor-on-hover"
                onClick={onActivate}>
                <TextBase
                  style={{ color: Colors.primary }}
                  fontWeight={600}
                  size={'var(--fs-body)'}
                  color={Colors.titlePage}>
                  activateSubscription
                </TextBase>
              </div>
            ) : 
            isCancelled ? (
            <div
              style={{ marginLeft: 'var(--sp-lg)' }}
              className="show-cursor-on-hover"
              onClick={onReactivate}>
              <TextBase
                style={{ color: Colors.primary }}
                fontWeight={600}
                size={'var(--fs-body)'}
                color={Colors.titlePage}>
                resumeMembership
              </TextBase>
            </div>
          ) : (
              <CreateaccountButton  onClick={onClickRight}>
                <TextBase
                  style={{ color: Colors.white }}
                  fontWeight={600}
                  size={'calc(var(--fs-xs)*1.320754)'}
                  color={Colors.titlePage}>
                  {btnText}
                </TextBase>
              </CreateaccountButton>
          )}
        </>
        {}
      </div>
    </div>
  );
};
